<template>
    <span>
        <a href="#"
            class="text-danger"
            @click.prevent="showDialog = true"
        >
            <i class="fas fa-pencil"></i>
        </a> 

        <el-dialog :visible.sync="showDialog"
                :close-on-click-modal="false"
                :close-on-press-escape="!processing"
                :show-close="!processing"
                :title="'Change Radius ' + title"
                append-to-body
            >

            <el-form :model="formData">
                <el-form-item label="Radius in miles">
                    <el-input-number v-model="formData.radius_miles"
                                    :disabled="processing"
                                    :step="1"
                                    :min="0"
                                    style="width:100%"/>
                </el-form-item>
            </el-form>

            <el-alert v-if="errorMessage !== null" title="Error: " type="error" :closable="false">
                {{ errorMessage }}
            </el-alert>

            <span slot="footer" class="dialog-footer">
                <el-button :disabled="processing" @click="showDialog = false">Cancel</el-button>
                <el-button :disabled="processing" type="success" @click="process">
                    <i v-if="processing" class="fa fa-pulse fa-spinner"></i> Change
                </el-button>
            </span>

        </el-dialog>
    </span>
</template>

<script>
    export default {
        props: {
            areaLocationId: { type: Number, required: true },
            location: { type: Object, required: true },
            radius: { type: Number, required: true },
        },
        data() {
            return {
                showDialog: false,
                formData: {
                    radius_miles: this.radius,
                },
                processing: false,
                errorMessage: null,
            };
        },
        computed: {
            title() {
                if(this.location.city) {
                    return this.location.city + ", " + this.location.state_code;
                }
                return this.location.zip_code;
            }
        },
        methods: {
            process() {
                this.processing = true;
                this.errorMessage = null;

                axios.post(this.url(`admin/area/update-location-radius`),
                    _.merge(this.formData, { id: this.areaLocationId }))
                    .then(response => {
                        if (typeof response.data.errors !== 'undefined' && response.data.errors !== null) {
                            this.errorMessage = response.data.errors;
                        } else {
                            this.$emit('process');
                            this.showDialog = false;
                        }
                    })
                    .catch(err => {
                        this.errorMessage = `Ooops, operation could not be performed due to: ${err.message}`;
                    })
                    .finally(() => { this.processing = false; });
            },
        },
    };
</script>
